// extracted by mini-css-extract-plugin
export default {"live":"EventState_live--tFs","time":"EventState_time--ApP","table":"EventState_table--ph2"};